import { TrackingService } from '@/providers/tracking/tracking.service';
import type { primitive } from '@/utils/typing/primitive.type';
import { Directive, HostListener, Input, inject } from '@angular/core';

@Directive({ selector: '[trackClick]' })
export class TrackClickDirective {
    private _trackingService = inject(TrackingService);

    @Input('trackClick') name?: string;
    @Input() trackClickDetails: Record<string, primitive> = {};

    @HostListener('click') onClick() {
        if (!this.name) {
            return;
        }
        this._trackingService.trackClick(this.name, this.trackClickDetails);
    }
}
